import React, { useEffect, useState } from 'react';
import { Badge, Card, CardBody, Table } from 'reactstrap';
import { request } from '../api';

// One answer's reported price history against Yahoo's daily bars as they stood
// when the run was asked. Not scored; it shows whether the model looked.
const FIELDS = ['session_date', 'open', 'high', 'low', 'close', 'return_5d_pct', 'high_20d', 'low_20d'];
const LABEL = { session_date: 'Session', open: 'Open', high: 'High', low: 'Low', close: 'Close', return_5d_pct: '5d %', high_20d: '20d high', low_20d: '20d low', avg_volume_20d: '20d avg volume' };
const COLOR = { accurate: 'success', deviation: 'warning', major_error: 'danger', stale: 'warning', missing: 'light', unverifiable: 'secondary' };
const num = v => (v == null ? '—' : Number(v).toLocaleString(undefined, { maximumFractionDigits: 2 }));

export default function OhlcChecks({ id }) {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    let live = true;
    request(`/predictions/${id}/ohlc-checks`).then(r => live && setRows(r)).catch(() => live && setRows([]));
    return () => { live = false; };
  }, [id]);
  if (!rows) return null;
  const symbols = [...new Set(rows.map(r => r.symbol))];
  const fields = rows.some(r => r.field === 'avg_volume_20d') ? [...FIELDS, 'avg_volume_20d'] : FIELDS;
  const cell = (symbol, f) => {
    const r = rows.find(x => x.symbol === symbol && x.field === f);
    if (!r) return <td key={f}>—</td>;
    const date = f === 'session_date' || /^d\d_date$/.test(f);
    const shown = date ? r.session_claimed || '—' : num(r.reported);
    const truth = date ? r.session_expected : num(r.actual);
    return <td key={f} title={`Yahoo: ${truth ?? '—'}${r.error_pct != null ? ` · off by ${Number(r.error_pct).toFixed(2)}${f === 'return_5d_pct' ? ' pp' : '%'}` : ''}`}>
      {shown}<br /><Badge color={COLOR[r.status] || 'light'} className={r.status === 'missing' ? 'text-body' : ''}>{r.status.replace('_', ' ')}</Badge></td>;
  };
  return <Card><CardBody>
    <h5 className="card-title mb-1">Price history check</h5>
    <p className="text-muted fs-12">Each figure the model reported, then Yahoo's (split-adjusted, not dividend-adjusted, sessions closed when asked). Within 0.5% is accurate, to 2% a deviation, beyond that a major error. Not scored.</p>
    {!rows.length ? <p className="text-muted mb-0">Not checked yet.</p> : <div className="table-responsive"><Table size="sm" className="align-middle fs-12 mb-0">
      <thead className="table-light"><tr><th>Symbol</th>{fields.map(f => <th key={f}>{LABEL[f]}</th>)}</tr></thead>
      <tbody>{symbols.map(symbol => <tr key={symbol}><td className="fw-medium">{symbol}</td>{fields.map(f => cell(symbol, f))}</tr>)}</tbody>
    </Table></div>}
    {symbols.filter(symbol => rows.some(r => r.symbol === symbol && r.field === 'd1_date')).map(symbol => <details key={symbol} className="mt-3">
      <summary className="text-muted fs-12">{symbol} · Last five completed sessions (oldest first)</summary>
      <div className="table-responsive mt-2"><Table size="sm" className="fs-12 mb-0">
        <thead><tr>{['Session', 'Open', 'High', 'Low', 'Close', 'Volume'].map(label => <th key={label}>{label}</th>)}</tr></thead>
        <tbody>{Array.from({ length: 5 }, (_, i) => <tr key={i}>{['date', 'open', 'high', 'low', 'close', 'volume'].map(f => cell(symbol, `d${i + 1}_${f}`))}</tr>)}</tbody>
      </Table></div>
    </details>)}
  </CardBody></Card>;
}
